import { useState } from "react";

const Header = (props) => {
    var _0x5674=["\x44\x61\x72\x6B","\x49\x6D\x61\x67\x65\x73\x2F\x6E\x69\x67\x68\x74\x2E\x70\x6E\x67","\x77\x68\x69\x74\x65","\x62\x6C\x61\x63\x6B","\x4C\x69\x67\x68\x74","\x49\x6D\x61\x67\x65\x73\x2F\x73\x75\x6E\x2E\x70\x6E\x67","\x75\x70\x64\x61\x74\x65\x54\x68\x65\x6D\x65","\x62\x61\x63\x6B\x67\x72\x6F\x75\x6E\x64\x43\x6F\x6C\x6F\x72","\x73\x74\x79\x6C\x65","\x62\x6F\x64\x79","\x23\x66\x31\x66\x32\x66\x36"];const [headtext,setheadtext]=useState(_0x5674[0]);const [path,setpath]=useState(_0x5674[1]);const [bgcolor,setbgcolor]=useState(_0x5674[2]);const [txtcolor,settxtcolor]=useState(_0x5674[3]);const changeTheme=()=>{if(headtext=== _0x5674[0]){setheadtext(_0x5674[4]);setpath(_0x5674[5]);setbgcolor(_0x5674[3]);settxtcolor(_0x5674[2]);props[_0x5674[6]]();document[_0x5674[9]][_0x5674[8]][_0x5674[7]]= _0x5674[3]}else {if(headtext=== _0x5674[4]){setheadtext(_0x5674[0]);setpath(_0x5674[1]);setbgcolor(_0x5674[2]);settxtcolor(_0x5674[3]);props[_0x5674[6]]();document[_0x5674[9]][_0x5674[8]][_0x5674[7]]= _0x5674[10]}}}

    return (
        <header style={{backgroundColor: bgcolor, color: txtcolor}}>
            <div className="head-container">
                <div className="logo">
                    <img src="Images/color-picker.png" alt="logo" />
                    <p>Image Color Picker</p>
                </div>
                <div className="theme" onClick={changeTheme}>
                    <img src={path} alt="night_theme" />
                    <p>{headtext} Mode</p>
                </div>
            </div>
        </header>
    );
};

export default Header;